import { createCtx } from 'shared/hooks/createCtx';
import { SanityProps } from '../types';

export const [useBabSanity, SanityBaBProvider] = createCtx<SanityProps>('SanityBaB-BuildBundleV3');
